import React, { Component } from 'react';

import { Error } from '../../shared/Error/Error';
import { LoadingIndicator } from '../../shared/LoadingIndicator/LoadingIndicator';
import MonitoredDocumentVersionList from './components/MonitoredDocumentVersionList.component';
import Pager from '../../shared/Pager/Pager';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

//import Can from '../Can';

// COMPONENT
class MonitoredDocumentVersionsBrowser extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { onInitialLoad } = this.props;

        try {
            onInitialLoad();
        } catch (err) {
            Swal({
                title: `Loading monitored document versions failed`,
                text: err,
                type: 'error',
            });
        }
    }

    render() {
        const {
            fetched,
            fetching,
            failed,
            monitoredDocumentVersions,
            onPageClick,
            paging: { pages, pageNumber },
            backLink,
        } = this.props;

        if (fetching && !fetched) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch monitored document version records" />;
        } else {
            return (
                // eslint-disable-next-line react/jsx-no-undef
                <div className="w-100">
                    <MonitoredDocumentVersionList
                        backLink={backLink}
                        monitoredDocumentVersions={monitoredDocumentVersions}
                    />
                    <Pager pages={pages} pageNumber={pageNumber} onPageChange={onPageClick} />
                </div>
            );
        }
    }
}

MonitoredDocumentVersionsBrowser.propTypes = {
    onInitialLoad: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    documentId: PropTypes.string.isRequired,
    monitoredDocumentVersions: PropTypes.array,
    failed: PropTypes.bool,
    onPageClick: PropTypes.func.isRequired,
    paging: PropTypes.shape({
        pages: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        pageNumber: PropTypes.number.isRequired,
    }),
    backLink: PropTypes.string,
};

export default MonitoredDocumentVersionsBrowser;
